<div class="body">

    <div class="hint">
        Wenn Sie diesen Filter teilen, dann wird eine Kopie des Filters in allen Widgets des Nutzer vom gleichen Typ erzeugt.
    </div>
    
    <div *ngFor="let user of users" class="user-wrapper" (click)="userClicked(user)">

        <mat-checkbox class="check-box" [checked]="userMap[user.id]">
            {{user.userName}}
        </mat-checkbox>
        
    </div>

</div>